import { Button, Card, Field, FileUpload, Heading, IconButton, Text } from '@components'
import { userId } from '@state'
import { Trash2Icon } from 'lucide-solid'
import { For, Show, createEffect, createResource, createSignal } from 'solid-js'
import { useService } from 'solid-services'
import { grid } from 'styled-system/patterns'
import { fetchImageUrl } from '../../../features/Avatar/fetchImageUrl'
import { useProfile } from '../state'

export const PictureUpload = () => {
	const [isValid, setIsValid] = createSignal(false)
	const { profilePictureResource, uploadProfilePicture, setFileChange, fileChange } =
		useService(useProfile)()

	const [imageUrl, { refetch }] = createResource(userId, fetchImageUrl, {
    initialValue: null
  })

	createEffect(() => {
		if (profilePictureResource.state === 'ready') {
			refetch()
		}
	})

	return (
		<Card.Root
			p={4}
			class={grid()}
		>
			<Heading>Image</Heading>
			<Text size="xs">
				images must be .jpg, .jpeg and .png only, and less than 200kbs
			</Text>

			<img
				src={imageUrl() ?? undefined}
				alt=""
			/>

			<FileUpload.Root
				maxFiles={1}
				validate={(file) => {
					if (file.size > 200 * 1024) {
						return ['FILE_TOO_LARGE']
					}

					const allowedTypes = ['image/jpeg', 'image/png']
					if (!allowedTypes.includes(file.type)) {
						return ['FILE_INVALID_TYPE']
					}
					return null
				}}
				onFileChange={(val) => setFileChange(val.acceptedFiles[0])}
			>
				<Show when={!fileChange()}>
					<FileUpload.Dropzone minH="100px">
						<FileUpload.Trigger
							asChild={(triggerProps) => (
								<Button
									variant="outline"
									size="sm"
									{...triggerProps()}
								>
									Upload Profile Picture
								</Button>
							)}
						/>
					</FileUpload.Dropzone>
				</Show>
				<FileUpload.ItemGroup>
					<FileUpload.Context>
						{(fileUpload) => (
							<For each={fileUpload().acceptedFiles}>
								{(file) => (
									<FileUpload.Item file={file}>
										<FileUpload.ItemPreview type="image/*">
											<FileUpload.ItemPreviewImage />
										</FileUpload.ItemPreview>
										<FileUpload.ItemName />
										<FileUpload.ItemSizeText />
										<FileUpload.ItemDeleteTrigger
											asChild={(triggerProps) => (
												<IconButton
													variant="link"
													size="sm"
													{...triggerProps()}
												>
													<Trash2Icon />
												</IconButton>
											)}
										/>
									</FileUpload.Item>
								)}
							</For>
						)}
					</FileUpload.Context>
				</FileUpload.ItemGroup>
				<FileUpload.HiddenInput />
			</FileUpload.Root>
			<Show when={fileChange()}>
				<Button
					loading={profilePictureResource.loading}
					onClick={uploadProfilePicture}
					justifySelf="start"
					colorPalette="tscGreen"
					variant="solid"
				>
					Save
				</Button>
			</Show>
		</Card.Root>
	)
}
